import { SWEEPSTAKES_CONSTANTS, SWEEPSTAKES_OVERLAY_EVENTS, GenericErrorMessage } from '../../../core/Constants';
import {
  analyticsSweepstakesDrawerOpen,
  analyticsSweepstakesDrawerOpenButton,
  analyticsSweepstakesTrackYourEntriesButton,
  analyticsSweepstakesOverlayExit,
  analyticsSweepstakesPostPageError,
} from '../../../common/utils/AnalyticsUtils';

const getStepTaskLabel = (step, index) => {
  if (index === 0) return 'survey';
  const trigger = step?.eventBusTrigger || '';
  const hasVideo = Boolean(step?.stepMetaData?.videoId || step?.stepMetaData?.brightcoveVideoId);
  if (hasVideo || trigger.includes('notifications')) return 'app';
  if (trigger.includes('store-mode')) return 'store mode';
  if (trigger.includes('shop')) return 'delivery';
  return 'app';
};

const STEP_COMPONENT_MAP = {
  survey: 'submit form: submit',
  delivery: 'get fast delivery: shop now',
  'store mode': 'try store mode: get started',
  app: 'meet the app: watch now',
};

const buildCampaignString = (steps) => {
  if (!steps || steps.length === 0) return '';
  return steps
    .map((step) => `${(step.title || '').toLowerCase()}: ${step.completed ? 'yes' : 'no'}`)
    .join(', ');
};

export const fireTrackYourEntriesButtonAnalytics = (clickedStep, clickedIndex, steps) => {
  const label = getStepTaskLabel(clickedStep, clickedIndex);
  const component = STEP_COMPONENT_MAP[label] || STEP_COMPONENT_MAP.survey;
  const campaign = buildCampaignString(steps);
  analyticsSweepstakesTrackYourEntriesButton(component, campaign);
};

const { DRAWER_TYPES } = SWEEPSTAKES_CONSTANTS;

const getStepOverlayEventName = (selectedStep) => {
  if (!selectedStep?.title) return null;
  return `fifa ${selectedStep.title}`.toLowerCase();
};

export const getDrawerOverlayEventName = (drawerType, selectedStep) => {
  switch (drawerType) {
  case DRAWER_TYPES.OPT_IN: return SWEEPSTAKES_OVERLAY_EVENTS.OPT_IN;
  case DRAWER_TYPES.SURVEY: return SWEEPSTAKES_OVERLAY_EVENTS.SURVEY;
  case DRAWER_TYPES.DETAILS: return SWEEPSTAKES_OVERLAY_EVENTS.DETAILS;
  case DRAWER_TYPES.STEP: return getStepOverlayEventName(selectedStep);
  default: return null;
  }
};

export const fireDrawerOverlayAnalytics = (drawerType, selectedStep, steps) => {
  const component = getDrawerOverlayEventName(drawerType, selectedStep);
  if (!component) return;
  const hasTasks = steps && steps.length > 0;
  const campaign = hasTasks ? buildCampaignString(steps) : 'n/a';
  const name = hasTasks && steps.every((step) => step.completed) ? 'complete' : 'incomplete';
  analyticsSweepstakesDrawerOpen(component, name, campaign);
};

export const fireDrawerOpenButtonAnalytics = (drawerType, selectedStep, steps) => {
  const component = getDrawerOverlayEventName(drawerType, selectedStep);
  if (!component) return;
  const hasTasks = steps && steps.length > 0;
  const campaign = hasTasks ? buildCampaignString(steps) : 'n/a';
  const name = hasTasks && steps.every((step) => step.completed) ? 'complete' : 'incomplete';
  analyticsSweepstakesDrawerOpenButton(component, name, campaign);
};

export const fireOverlayExitAnalytics = (drawerType, selectedStep, steps) => {
  const component = getDrawerOverlayEventName(drawerType, selectedStep);
  if (!component) return;
  const hasTasks = steps && steps.length > 0;
  const campaign = hasTasks ? buildCampaignString(steps) : 'n/a';
  const name = hasTasks && steps.every((step) => step.completed) ? 'complete' : 'incomplete';
  analyticsSweepstakesOverlayExit(component, name, campaign);
};

export const firePostPageErrorAnalytics = (drawerType, selectedStep) => {
  const pageSection = getDrawerOverlayEventName(drawerType, selectedStep) || 'fifa sweepstakes';
  analyticsSweepstakesPostPageError({
    type: 'system',
    displayType: 'inline',
    pageSection,
    message: GenericErrorMessage,
    code: 'n/a',
  });
};
